import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Router, ActivatedRoute } from '@angular/router';
import { BomLine } from '../../api/models/bom-line';
import { CommentsAdapterService } from '../comments/comments-adapter.service';
import { Location } from '@angular/common';
import { ProjectService } from '../../api/services/project.services';
import { AuthService } from '../../api/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImportExportComponent } from './import-export/import-export.component';
import { UserService } from '../../api/services/user.service';
import { MarketService } from '../../api/services/market.service';
import { Market } from '../../api/models/market-model';


@Component({
  selector: 'app-order-worksheet',
  templateUrl: './order-worksheet.component.html',
  styleUrls: ['./order-worksheet.component.scss'],
  providers: [CommentsAdapterService]
})
export class OrderWorksheetComponent implements OnInit {

  backToSearch: string;

  mosCurrentStatusFilter: string;

  mosCurrentOwnerFilter: string;

  mosCurrentApproverFilter: string;

  bomLinesToAdd = new Subject<BomLine[]>();

  worksheetId: string;

  userRoles: string[];

  importExportDisable: boolean = true;

  editWorksheetMode: boolean = false;

  errorMessage: string[] = [];

  marketId: string;

  market: Market;

  constructor(
    private userService: UserService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private projectService: ProjectService,
    private authService: AuthService,
    private marketService: MarketService,
    private modalService: NgbModal
  ) { }

  onMasterBomQtySelected(bomLines: BomLine[]) {
    this.bomLinesToAdd.next(bomLines);
  }

  openImportExportDialog() {
    const modalRef = this.modalService.open(ImportExportComponent, {
      backdrop : 'static',
      keyboard : false
    });
    modalRef.componentInstance.worksheetId = this.worksheetId;
    modalRef.componentInstance.exportDisable = this.importExportDisable;

    modalRef.result.then(result => { this.importExportDisable = result; }).catch(() => { 
      //Empty catch block
    });
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.backToSearch = params['backToSearch'];
      this.mosCurrentStatusFilter = params['currentStatusFilter'];
      this.mosCurrentOwnerFilter = params['currentOwnerFilter'];
      this.mosCurrentApproverFilter = params['currentApproverFilter'];
    });
    
    this.activatedRoute
      .params.map(p => p.id)
      .subscribe(worksheetId => {
        this.projectService.getWorksheet(worksheetId).subscribe(worksheet => {
          this.marketService.getMarket(worksheet.project.marketId).subscribe(market => {
            if (market) {
              this.market = market;
              if (worksheet.project.active) {
                this.marketId = worksheet.project.marketId;
                this.worksheetId = worksheetId;
                this.projectService.updateWorksheetWatchers(worksheetId).subscribe();
              } else {
                this.errorMessage.push("Project marked as inactive. You cannot view this page!!!");
              }
            } else {
              this.errorMessage.push("You don't have permission to view this page!!!")
            }
          }, error => {
            this.errorMessage.push(error.error.message);
          });
        }, error => {
          this.errorMessage.push(error.error.message);
        });
      });
    this.importExportDisable = true;
  }

  goBack(): void {
    this.location.back();
  }

  saveEvent($event) {
    this.importExportDisable = $event;
  }

  editEvent($event) {
    this.editWorksheetMode = $event;
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/order-worksheet/order-worksheet.component.ts